var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"Resizer",style:(_vm.resStyle),on:{"mouseover":function($event){_vm.isMouseOver = true},"mouseout":function($event){_vm.isMouseOver = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }